
function openCartDrawer(){
  
    const siteOverlay = document.querySelector('[data-component="site-overlay"]');
    siteOverlay.dataset.animationState = 'open';
    
    const cartDrawer = document.querySelector('[data-component="flyout"]');
    cartDrawer.dataset.animationState = 'open';
  
}

setTimeout(function() {
  
  const previousPage = document.referrer;
  if(previousPage == 'https://www.nine-worths.com/cart'){
    //openCartDrawer();
  }
  
}, 2000);